import React from 'react';
import { Phone } from 'lucide-react';
import { motion } from 'framer-motion';
export function Header() {
  return <motion.header initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.5
  }} className="fixed top-0 left-0 right-0 z-50 bg-[#F4F4F5] border-b-2 border-black" data-id="element-50">
      <div className="max-w-[1400px] mx-auto px-6 h-20 flex items-center justify-between" data-id="element-51">
        <div className="flex items-center gap-4" data-id="element-52">
          <div className="w-12 h-12 bg-black flex items-center justify-center" data-id="element-53">
            <span className="text-white font-oswald font-bold text-2xl leading-none" data-id="element-54">
              ВА
            </span>
          </div>
          <div className="flex flex-col" data-id="element-55">
            <span className="font-oswald font-bold text-xl tracking-wide leading-none" data-id="element-56">
              ВІЙСЬКОВИЙ АДВОКАТ
            </span>
            <span className="text-xs font-medium uppercase tracking-widest mt-1" data-id="element-57">
              Юридична практика
            </span>
          </div>
        </div>

        <a href="tel:+380687870587" className="flex items-center gap-3 px-6 py-3 bg-black hover:bg-white hover:text-black text-white border-2 border-black transition-colors text-sm font-bold uppercase tracking-widest" data-id="element-58">
          <Phone className="w-4 h-4" data-id="element-59" />
          <span className="hidden sm:inline" data-id="element-60">068 787 0587</span>
        </a>
      </div>
    </motion.header>;
}